export default __webpack_public_path__ + "static/media/hidraulic13.189023a2.jpg";